import { createFileRoute, redirect } from '@tanstack/react-router';

// The sidebar's Lead Lists page lives at /lists. People type the label as a
// path (/lead-lists), so send them there instead of to Page not found.
export const Route = createFileRoute('/lead-lists')({
  beforeLoad: ({ location }) => {
    throw redirect({ to: '/lists', search: location.search, replace: true });
  },
});
